import React from 'react';

export const link = `mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`;

export default function SupportEmail() {
  return <a href={link}>{process.env.REACT_APP_SUPPORT_EMAIL}</a>;
}